const KEY = "dylan-songbook-v1";
export const uid = () => Math.random().toString(36).slice(2, 10);
export function loadStore() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}
export function saveStore(data) {
  localStorage.setItem(KEY, JSON.stringify(data));
}
